// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-view-application-stakeholders-itams) {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 50px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  width: 100%;
}

.traders-form {
  height: 100%;
  padding-left: 5px;
  padding-right: 5px;
}

.remove-button {
  margin-left: 10px;
}

.error-div {
  height: 30px;
}

.error-small {
  font-size: 12px;
  white-space: pre;
}

.step-header {
  font-size: 17px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 20px;
  margin-left: 10px;
  color: var(--theme-main-color, #055C8D);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
